import React from 'react';
import style from './style.scss'



const Label = props => {
    const {label, id,parentClass} = props;
    return (
        <label className={style.firstLabel+' '+(label.second&&style.hasSecond)+' '+parentClass}
            htmlFor={id} >
            {(typeof label === `string`) ? label : label.first}
        </label>
    )
}

export default Label;
